import React from "react";
import tw from "twin.macro";
import {Container as ContainerBase } from "components/misc/Layouts.js"
import { ReactComponent as DiscordIcon } from "images/discord-icon.svg";
import { ReactComponent as TiktokIcon } from "images/tiktok-icon.svg";
import { ReactComponent as InstagramIcon } from "feather-icons/dist/icons/instagram.svg";
import logo from "../images/rewind_color.png";


const Container = tw(ContainerBase)`bg-gray-900 text-gray-100 -mx-8 -mb-8`
const Content = tw.div`max-w-screen-xl mx-auto py-16 lg:py-16`;

const Row = tw.div`flex items-center justify-center flex-col px-8`

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-56`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`
export default () => {
  return (
    <Container>
      <Content>
        <Row>
          <LogoContainer>
            <LogoImg src={logo} />
          </LogoContainer>
          <LinksContainer>
            <Link href="/">Home</Link>
            <Link href="/staff">Chi siamo</Link>
            <Link href="#">Contattaci</Link>
            <Link href="#">Changelog</Link>
            <Link href="#">UCP</Link>
          </LinksContainer>
          <LinksContainer>
            <Link href="https://discord.gg/EfFFvX5qrP"><DiscordIcon tw="w-10 h-10" /></Link>
            <Link href="https://instagram.com/rewindrp.it/"><InstagramIcon tw="w-10 h-10 text-orange-600" /></Link>
            <Link href="https://www.tiktok.com/@rewindrp_"><TiktokIcon tw="w-10 h-10" /></Link>
          </LinksContainer>
          <CopyrightText>
            &copy; Rewind Roleplay 2022.
          </CopyrightText>
          <CopyrightText>
            &diams; FedeFluork
          </CopyrightText>
        </Row>
      </Content>
    </Container>
  );
};
